import React, {useMemo} from 'react'
import {Column, ColumnInstance, Row, useTable} from 'react-table'
import {DetailBatchRecord} from '../../../interfaces/batch'
import {ListLoading} from './loading/ListLoading'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'

type Props = {
  batchList: DetailBatchRecord[]
  isLoading: boolean
  columns: readonly Column<DetailBatchRecord>[]
}

export default function CustomTable({batchList, isLoading, columns: paramColumns}: Props) {
  const data = useMemo(() => batchList, [batchList])
  const columns = useMemo(() => paramColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  return (
    <>
      <div className='table-responsive'>
        <table
          className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-10'
          {...getTableProps()}
        >
          <thead>
            <tr className='fs-3 text-gray'>
              {headers.map((column: ColumnInstance<DetailBatchRecord>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray fs-2 fw-semibold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<DetailBatchRecord>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No se encontraron registros coincidentes
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {isLoading && <ListLoading />}
    </>
  )
}
